import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { loadECMRFromLocalStorage, saveECMR } from '../services/eCMRService';
import { ECMR } from '../types/eCMR';
import ECMRForm from './ECMRForm';

const EditECMR: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [ecmr, setEcmr] = useState<ECMR | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  
  useEffect(() => {
    if (!id) {
      setError('ID de e-CMR no proporcionado');
      setLoading(false);
      return;
    }
    
    const loadData = () => {
      try {
        const loadedEcmr = loadECMRFromLocalStorage(id);
        if (!loadedEcmr) {
          setError('e-CMR no encontrado');
          setLoading(false);
          return;
        }
        
        setEcmr(loadedEcmr);
        setLoading(false);
      } catch (err) {
        setError(`Error al cargar e-CMR: ${(err as Error).message}`);
        setLoading(false);
      }
    };
    
    loadData();
  }, [id]);
  
  const handleSubmit = (data: ECMR) => {
    try {
      // Guardar el eCMR editado
      saveECMR(data);
      navigate(`/view/${id}`);
    } catch (error) {
      console.error('Error al guardar el e-CMR:', error);
      alert('Error al guardar el e-CMR');
    }
  };
  
  const handleCancel = () => {
    navigate(`/view/${id}`);
  };
  
  if (loading) {
    return (
      <div className="container mx-auto p-4">
        <div className="text-center">
          <p className="text-lg">Cargando...</p>
        </div>
      </div>
    );
  }
  
  if (error || !ecmr) {
    return (
      <div className="container mx-auto p-4">
        <div className="bg-red-100 border-l-4 border-red-500 text-red-700 p-4 mb-4">
          <p>{error || 'Error al cargar el e-CMR'}</p>
        </div>
        <button
          onClick={() => navigate('/')}
          className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
        >
          Volver a la lista
        </button>
      </div>
    );
  }
  
  return (
    <div className="container mx-auto p-4">
      <h1 className="text-2xl font-bold mb-6">
        Editar e-CMR: {ecmr.ExchangedDocument?.ID || 'Sin título'}
      </h1>
      <ECMRForm
        initialData={ecmr}
        onSubmit={handleSubmit}
        onCancel={handleCancel}
      />
    </div>
  );
};

export default EditECMR;